<template>
  <Modal :modalActive="modalActive" @cerrar-modal="onCerrar">
    <div class="msl-wrap">

      <!-- CABECERA -->
      <div class="msl-header">
        <span class="msl-badge">Landing</span>
        <h5 class="msl-title">
          <span v-if="fase === 'parametros'">Parámetros de campaña</span>
          <span v-else-if="fase === 'galeria'">Selecciona una plantilla</span>
          <span v-else-if="fase === 'procesando'">Creando landing…</span>
          <span v-else>Landing publicada</span>
        </h5>
      </div>

      <!-- ─── FASE 0: PARÁMETROS ──────────────────────────────── -->
      <template v-if="fase === 'parametros'">
        <div v-if="cargandoOpciones" class="msl-state">
          <i class="fa fa-spinner fa-spin"></i>
          <span>Cargando opciones…</span>
        </div>
        <div v-else class="msl-params">

          <!-- Mercado -->
          <div class="msl-param-group">
            <div class="msl-label-row">
              <span class="msl-param-label">Mercado</span>
              <button class="msl-add-btn" @click="mostrarAgregar('mercado')" title="Añadir mercado">+</button>
            </div>
            <div class="msl-radio-grid">
              <label v-for="m in opciones.mercado" :key="m.valor" class="msl-radio-pill" :class="{ active: params.mercado === m.valor }">
                <input type="radio" v-model="params.mercado" :value="m.valor" class="msl-radio-hidden">
                {{ m.valor }}
              </label>
            </div>
            <div v-if="agregar.tipo === 'mercado'" class="msl-inline-add">
              <input ref="inputAgregar" v-model="agregar.valor" class="msl-add-input" placeholder="Ej: BRA" maxlength="20"
                @keydown.enter.prevent="confirmarAgregar" @keydown.esc="cancelarAgregar" />
              <button class="msl-add-ok" :disabled="agregar.guardando || !agregar.valor.trim()" @click="confirmarAgregar">
                <i v-if="agregar.guardando" class="fa fa-spinner fa-spin"></i>
                <span v-else>✓</span>
              </button>
              <button class="msl-add-cancel" @click="cancelarAgregar">✕</button>
              <span v-if="agregar.error" class="msl-add-error">{{ agregar.error }}</span>
            </div>
          </div>

          <!-- Tipo de campaña -->
          <div class="msl-param-group">
            <div class="msl-label-row">
              <span class="msl-param-label">Tipo de campaña</span>
              <button class="msl-add-btn" @click="mostrarAgregar('tipo_campana')" title="Añadir tipo de campaña">+</button>
            </div>
            <div class="msl-radio-row">
              <label v-for="t in opciones.tipo_campana" :key="t.valor" class="msl-radio-pill msl-radio-pill--lg" :class="{ active: params.tipoCampana === t.valor }">
                <input type="radio" v-model="params.tipoCampana" :value="t.valor" class="msl-radio-hidden">
                <span class="msl-pill-cod">{{ t.valor }}</span>
                <span class="msl-pill-desc">{{ t.label }}</span>
              </label>
            </div>
            <div v-if="agregar.tipo === 'tipo_campana'" class="msl-inline-add">
              <input ref="inputAgregar" v-model="agregar.valor" class="msl-add-input msl-add-input--sm" placeholder="Código (ej: BRD)" maxlength="10"
                @keydown.esc="cancelarAgregar" />
              <input v-model="agregar.label" class="msl-add-input" placeholder="Descripción (ej: Brand)" maxlength="100"
                @keydown.enter.prevent="confirmarAgregar" @keydown.esc="cancelarAgregar" />
              <button class="msl-add-ok" :disabled="agregar.guardando || !agregar.valor.trim()" @click="confirmarAgregar">
                <i v-if="agregar.guardando" class="fa fa-spinner fa-spin"></i>
                <span v-else>✓</span>
              </button>
              <button class="msl-add-cancel" @click="cancelarAgregar">✕</button>
              <span v-if="agregar.error" class="msl-add-error">{{ agregar.error }}</span>
            </div>
          </div>

          <!-- Tipo de audiencia -->
          <div class="msl-param-group">
            <div class="msl-label-row">
              <span class="msl-param-label">Tipo de audiencia</span>
              <button class="msl-add-btn" @click="mostrarAgregar('tipo_audiencia')" title="Añadir tipo de audiencia">+</button>
            </div>
            <div class="msl-radio-row">
              <label v-for="a in opciones.tipo_audiencia" :key="a.valor" class="msl-radio-pill" :class="{ active: params.tipoAudiencia === a.valor }">
                <input type="radio" v-model="params.tipoAudiencia" :value="a.valor" class="msl-radio-hidden">
                {{ a.valor }}
              </label>
            </div>
            <div v-if="agregar.tipo === 'tipo_audiencia'" class="msl-inline-add">
              <input ref="inputAgregar" v-model="agregar.valor" class="msl-add-input" placeholder="Ej: RETENCION" maxlength="30"
                @keydown.enter.prevent="confirmarAgregar" @keydown.esc="cancelarAgregar" />
              <button class="msl-add-ok" :disabled="agregar.guardando || !agregar.valor.trim()" @click="confirmarAgregar">
                <i v-if="agregar.guardando" class="fa fa-spinner fa-spin"></i>
                <span v-else>✓</span>
              </button>
              <button class="msl-add-cancel" @click="cancelarAgregar">✕</button>
              <span v-if="agregar.error" class="msl-add-error">{{ agregar.error }}</span>
            </div>
          </div>

          <!-- Tipo de segmentación -->
          <div class="msl-param-group">
            <div class="msl-label-row">
              <span class="msl-param-label">Tipo de segmentación <span class="msl-opt">(opcional)</span></span>
              <button class="msl-add-btn" @click="mostrarAgregar('segmentacion')" title="Añadir segmentación">+</button>
            </div>
            <select v-model="params.tipoSegmentacion" class="msl-select">
              <option value="">— Sin segmentación específica —</option>
              <option v-for="s in opciones.segmentacion" :key="s.valor" :value="s.valor"
                :style="s.valor === segmentacionNueva ? { color: '#ffd700', fontWeight: '700' } : {}">
                {{ s.valor }}{{ s.valor === segmentacionNueva ? ' ✦' : '' }}
              </option>
            </select>
            <div v-if="agregar.tipo === 'segmentacion'" class="msl-inline-add">
              <input ref="inputAgregar" v-model="agregar.valor" class="msl-add-input" placeholder="Ej: SIM+TEN" maxlength="50"
                @keydown.enter.prevent="confirmarAgregar" @keydown.esc="cancelarAgregar" />
              <button class="msl-add-ok" :disabled="agregar.guardando || !agregar.valor.trim()" @click="confirmarAgregar">
                <i v-if="agregar.guardando" class="fa fa-spinner fa-spin"></i>
                <span v-else>✓</span>
              </button>
              <button class="msl-add-cancel" @click="cancelarAgregar">✕</button>
              <span v-if="agregar.error" class="msl-add-error">{{ agregar.error }}</span>
            </div>
          </div>

        </div>

        <div class="msl-actions">
          <button class="msl-btn msl-btn--sec" @click="onCerrar">Cancelar</button>
          <button class="msl-btn msl-btn--pri" :disabled="!paramsCompletos" @click="fase = 'galeria'">
            Continuar <i class="fa fa-arrow-right ms-1"></i>
          </button>
        </div>
      </template>

      <!-- ─── FASE 1: GALERÍA ───────────────────────────────────── -->
      <template v-if="fase === 'galeria'">

        <!-- Barra superior: idioma + banner -->
        <div class="msl-top-bar">
          <!-- Selector de idioma (solo activo en templates de catálogo) -->
          <div class="msl-idioma-wrap" :class="{ 'msl-idioma-wrap--disabled': esPorDefecto }">
            <span class="msl-top-label">Idioma</span>
            <div class="msl-idioma-btns">
              <button
                v-for="lang in idiomas" :key="lang.val"
                class="msl-idioma-btn"
                :class="{ active: idioma === lang.val }"
                :disabled="esPorDefecto"
                @click="idioma = lang.val"
                :title="esPorDefecto ? 'El idioma de la personalización es fijo' : ''"
              >{{ lang.flag }} {{ lang.label }}</button>
            </div>
          </div>
          <!-- Banner toggle -->
          <div v-if="tieneBanner" class="msl-banner-toggle">
            <label class="msl-toggle-label">
              <input type="checkbox" v-model="conBanner" class="msl-toggle-input">
              <span class="msl-toggle-box"><i class="fa fa-image me-1"></i> Incluir Banner</span>
            </label>
          </div>
        </div>

        <div class="msl-body">

          <!-- Columna izquierda: filtros + grid -->
          <div class="msl-left">
            <!-- Filtros por categoría -->
            <div class="msl-filtros">
              <button
                v-for="cat in categorias" :key="cat.val"
                class="msl-chip"
                :class="{ active: filtro === cat.val }"
                @click="filtro = cat.val"
              >{{ cat.label }}</button>
            </div>

            <!-- Estado de carga -->
            <div v-if="cargando" class="msl-state">
              <i class="fa fa-spinner fa-spin"></i>
              <span>Cargando plantillas…</span>
            </div>
            <div v-else-if="errorMsg" class="msl-state msl-state--error">
              <i class="fa fa-exclamation-circle"></i>
              <span>{{ errorMsg }}</span>
            </div>

            <!-- Grid de tarjetas: personalizaciones + catálogo -->
            <div v-else class="msl-grid">

              <!-- Personalizations: siempre visibles como primera opción -->
              <template v-if="personalizaciones.length">
                <div class="msl-section-label">Mis personalizaciones</div>
                <div
                  v-for="p in personalizaciones" :key="'pers-' + p.id"
                  class="msl-card msl-card--pers"
                  :class="{ 'msl-card--sel': personalizacionId === p.id && esPorDefecto }"
                  @click="seleccionarPersonalizacion(p)"
                >
                  <div class="msl-card-inner">
                    <span class="msl-card-check" v-if="personalizacionId === p.id && esPorDefecto">
                      <i class="fa fa-check-circle"></i>
                    </span>
                    <i class="fa fa-star msl-pers-icon" v-else></i>
                    <span class="msl-card-nombre">{{ p.nombre || 'Sin nombre' }}</span>
                    <span class="msl-cat msl-cat--default">Estándar</span>
                  </div>
                </div>
                <div class="msl-section-label">Catálogo</div>
              </template>

              <div
                v-for="t in templatesFiltrados" :key="t.id"
                class="msl-card"
                :class="{ 'msl-card--sel': templateId === t.id && !esPorDefecto }"
                @click="seleccionar(t)"
              >
                <div class="msl-card-inner">
                  <span class="msl-card-check" v-if="templateId === t.id && !esPorDefecto">
                    <i class="fa fa-check-circle"></i>
                  </span>
                  <span class="msl-card-nombre">{{ t.nombre }}</span>
                  <span class="msl-cat" :class="'msl-cat--' + t.categoria">
                    {{ catLabel(t.categoria) }}
                  </span>
                </div>
              </div>
              <p v-if="templatesFiltrados.length === 0" class="msl-empty">
                No hay plantillas en esta categoría.
              </p>
            </div>
          </div>

          <!-- Columna derecha: vista previa -->
          <div class="msl-right">
            <div v-if="!templateId" class="msl-preview-empty">
              <i class="fa fa-eye fa-2x"></i>
              <p>Selecciona una plantilla<br>para ver la vista previa</p>
            </div>
            <div v-else class="msl-preview-wrap">
              <div v-if="loadingPreview" class="msl-state">
                <i class="fa fa-spinner fa-spin"></i>
              </div>
              <div class="msl-iframe-clip" ref="previewClip" v-show="!loadingPreview && previewHtml">
                <iframe
                  ref="previewFrame"
                  class="msl-iframe"
                  scrolling="no"
                  sandbox="allow-scripts allow-same-origin"
                  :srcdoc="previewHtml"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- Acciones -->
        <div class="msl-actions">
          <button class="msl-btn msl-btn--sec" @click="onOmitir">Omitir</button>
          <button
            class="msl-btn msl-btn--pri"
            :disabled="!templateId"
            @click="crearYPublicar"
          >
            <i class="fa fa-rocket me-1"></i>
            Crear landing
          </button>
        </div>
      </template>

      <!-- ─── FASE 2: PROCESANDO ───────────────────────────────── -->
      <div v-else-if="fase === 'procesando'" class="msl-state msl-state--spin">
        <i class="fa fa-spinner fa-spin fa-2x"></i>
        <p>Generando y publicando la landing…</p>
      </div>

      <!-- ─── FASE 3: ÉXITO ────────────────────────────────────── -->
      <div v-else-if="fase === 'exito'" class="msl-exito">
        <div class="msl-exito-icon"><i class="fa fa-check-circle"></i></div>
        <h6>¡Landing publicada!</h6>
        <p class="msl-exito-sub">Usa este enlace en tus anuncios de Meta Ads:</p>
        <div class="msl-url-row">
          <span class="msl-url-text">{{ urlPublica }}</span>
          <button class="msl-copy-btn" @click="copiarUrl" :title="copiado ? 'Copiado' : 'Copiar'">
            <i class="fa" :class="copiado ? 'fa-check' : 'fa-copy'"></i>
          </button>
        </div>
        <button class="msl-btn msl-btn--pri mt-3" @click="onCerrar">Cerrar</button>
      </div>

    </div>
  </Modal>
</template>

<script>
import Modal from './Modal.vue';
import campanasService from '@/services/campanas.service.js';

const IDIOMAS = [
  { val: 'es', flag: '🇪🇸', label: 'ES' },
  { val: 'en', flag: '🇬🇧', label: 'EN' },
  { val: 'pt', flag: '🇵🇹', label: 'PT' },
  { val: 'fr', flag: '🇫🇷', label: 'FR' },
  { val: 'de', flag: '🇩🇪', label: 'DE' },
  { val: 'it', flag: '🇮🇹', label: 'IT' },
];

const CATEGORIAS = [
  { val: '', label: 'Todas' },
  { val: 'clasica', label: 'Clásica' },
  { val: 'foto', label: 'Foto' },
  { val: 'minimal', label: 'Minimal' },
  { val: 'especial', label: 'Especial' },
  { val: 'especial-foto', label: 'Esp. foto' },
];

const CAT_LABELS = {
  'clasica': 'Clásica',
  'foto': 'Foto',
  'minimal': 'Minimal',
  'especial': 'Especial',
  'especial-foto': 'Esp. foto',
};


export default {
  name: 'ModalSeleccionLanding',
  components: { Modal },

  props: {
    modalActive: { type: Boolean, default: false },
    campanaId:   { type: Number, default: 0 },
  },

  emits: ['cerrar-modal', 'guardado'],

  data() {
    return {
      fase: 'parametros',
      params: { mercado: '', tipoCampana: '', tipoAudiencia: '', tipoSegmentacion: '' },
      opciones: { mercado: [], tipo_campana: [], tipo_audiencia: [], segmentacion: [] },
      cargandoOpciones: false,
      agregar: { tipo: null, valor: '', label: '', guardando: false, error: '' },
      segmentacionNueva: null,
      templates: [],
      templateId: null,
      filtro: '',
      cargando: false,
      loadingPreview: false,
      errorMsg: '',
      previewHtml: '',
      previewCache: {},
      urlPublica: '',
      copiado: false,
      categorias: CATEGORIAS,
      idiomas: IDIOMAS,
      idioma: 'es',
      tipsterInfo: null,
      personalizaciones: [],
      personalizacionId: null,
      conBanner: false,
      esPorDefecto: false,
    };
  },

  computed: {
    templatesFiltrados() {
      const visible = this.templates.filter(t => t.slug !== 'oscura');
      if (!this.filtro) return visible;
      return visible.filter(t => t.categoria === this.filtro);
    },
    paramsCompletos() {
      return this.params.mercado && this.params.tipoCampana && this.params.tipoAudiencia;
    },
    personalizacionActual() {
      return this.personalizaciones.find(p => p.id === this.personalizacionId) || null;
    },
    tieneBanner() {
      return this.personalizacionActual ? this.personalizacionActual.tiene_banner : (this.tipsterInfo && this.tipsterInfo.tiene_banner);
    },
  },

  watch: {
    modalActive(val) {
      if (val) this.init();
    },
    conBanner() {
      this.recargarPreview();
    },
    idioma() {
      if (!this.esPorDefecto) this.recargarPreview();
    },
  },

  methods: {
    async init() {
      this.fase = 'parametros';
      this.params = { mercado: '', tipoCampana: '', tipoAudiencia: '', tipoSegmentacion: '' };
      this.templateId = null;
      this.filtro = '';
      this.errorMsg = '';
      this.previewHtml = '';
      this.urlPublica = '';
      this.copiado = false;
      this.previewCache = {};
      this.tipsterInfo = null;
      this.personalizaciones = [];
      this.personalizacionId = null;
      this.conBanner = false;
      this.templates = [];
      this.esPorDefecto = false;
      this.idioma = 'es';
      this.cancelarAgregar();

      const catalogoPromise = campanasService.landingCatalogo(this.campanaId).then(data => {
        this.templates = data.templates || [];
        this.tipsterInfo = data.tipster_info || null;
        this.personalizaciones = data.tipster_info?.personalizaciones || [];
        if (this.personalizaciones.length) {
          this.personalizacionId = this.personalizaciones[0].id;
        }
      }).catch(() => {
        this.errorMsg = 'No se pudo cargar el catálogo de plantillas.';
      });

      const opcionesPromise = !this.opciones.mercado.length ? this.cargarOpciones() : Promise.resolve();

      this.cargando = true;
      await Promise.all([catalogoPromise, opcionesPromise]);
      this.cargando = false;
      // Pre-cargar preview de la primera personalización (en background, antes de entrar a la galería)
      if (this.personalizaciones.length && this.templates.length) {
        this.seleccionarPersonalizacion(this.personalizaciones[0]);
      }
    },

    async cargarOpciones() {
      this.cargandoOpciones = true;
      try {
        const res = await campanasService.metaParametros();
        if (res?.data) {
          this.opciones.mercado        = res.data.mercado        || [];
          this.opciones.tipo_campana   = res.data.tipo_campana   || [];
          this.opciones.tipo_audiencia = res.data.tipo_audiencia || [];
          this.opciones.segmentacion   = res.data.segmentacion   || [];
        }
      } catch {
        // si falla, el usuario verá la lista vacía pero no bloquea el flujo
      } finally {
        this.cargandoOpciones = false;
      }
    },

    mostrarAgregar(tipo) {
      this.agregar = { tipo, valor: '', label: '', guardando: false, error: '' };
      this.$nextTick(() => { this.$refs.inputAgregar?.focus(); });
    },

    cancelarAgregar() {
      this.agregar = { tipo: null, valor: '', label: '', guardando: false, error: '' };
    },

    async confirmarAgregar() {
      const { tipo, valor, label } = this.agregar;
      if (!valor.trim()) return;
      this.agregar.guardando = true;
      this.agregar.error = '';
      try {
        const res = await campanasService.metaParametrosCrear(tipo, valor.trim(), label?.trim() || null);
        if (res?.ok && res.data) {
          this.opciones[tipo].push(res.data);
          if (tipo === 'segmentacion') {
            this.opciones.segmentacion.sort((a, b) => a.valor.localeCompare(b.valor, undefined, { sensitivity: 'base' }));
            this.segmentacionNueva = res.data.valor;
          }
          if (tipo === 'mercado')        this.params.mercado          = res.data.valor;
          if (tipo === 'tipo_campana')   this.params.tipoCampana      = res.data.valor;
          if (tipo === 'tipo_audiencia') this.params.tipoAudiencia    = res.data.valor;
          if (tipo === 'segmentacion')   this.params.tipoSegmentacion = res.data.valor;
          this.cancelarAgregar();
        }
      } catch (e) {
        const msg = e?.response?.data?.message || e?.response?.data?.errors?.valor?.[0] || 'Error al guardar';
        this.agregar.error = msg;
      } finally {
        this.agregar.guardando = false;
      }
    },

    async seleccionarPersonalizacion(p) {
      this.personalizacionId = p.id;
      this.conBanner = false;
      this.previewCache = {};
      // La personalización ES la landing: usar template oscura (la que renderiza el fondo propio)
      const t = this.templates.find(tpl => tpl.slug === 'oscura')
        || this.templates.find(tpl => tpl.requiere_fondo)
        || this.templatesFiltrados[0]
        || null;
      this.esPorDefecto = true;
      if (t) await this.cargarPreview(t);
    },

    async seleccionar(t) {
      this.esPorDefecto = false;
      if (this.personalizacionActual?.idioma) {
        this.idioma = this.personalizacionActual.idioma;
      }
      await this.cargarPreview(t);
    },

    async cargarPreview(t) {
      this.templateId = t.id;
      // idioma: solo se pasa como override cuando el usuario elige una template del catálogo
      const idiomaOverride = this.esPorDefecto ? null : this.idioma;
      const cacheKey = `${this.campanaId}_${t.id}_${this.conBanner ? 1 : 0}_${this.personalizacionId || 0}_${idiomaOverride || ''}`;
      if (this.previewCache[cacheKey]) {
        this.previewHtml = this.previewCache[cacheKey];
        return;
      }
      this.loadingPreview = true;
      this.previewHtml = '';
      try {
        const html = await campanasService.landingPreview(t.id, this.campanaId, this.conBanner, this.personalizacionId, idiomaOverride);
        this.previewCache[cacheKey] = html;
        this.previewHtml = html;
      } catch {
        this.previewHtml = '';
      } finally {
        this.loadingPreview = false;
      }
    },

    async recargarPreview() {
      if (!this.templateId) return;
      const t = this.templates.find(tpl => tpl.id === this.templateId);
      if (!t) return;
      const cacheKey = `${this.campanaId}_${t.id}_${this.conBanner ? 1 : 0}_${this.personalizacionId || 0}`;
      delete this.previewCache[cacheKey];
      await this.cargarPreview(t);
    },

    idiomaFlag(idioma) {
      const flags = { es: '🇪🇸', en: '🇬🇧', pt: '🇵🇹', fr: '🇫🇷', de: '🇩🇪', it: '🇮🇹' };
      return flags[idioma] || idioma;
    },


    catLabel(cat) {
      return CAT_LABELS[cat] || cat;
    },

    async crearYPublicar() {
      if (!this.templateId || !this.campanaId) return;
      this.fase = 'procesando';
      try {
        const parametros = {
          mercado:            this.params.mercado           || undefined,
          tipo_campana:       this.params.tipoCampana       || undefined,
          tipo_audiencia:     this.params.tipoAudiencia     || undefined,
          tipo_segmentacion:  this.params.tipoSegmentacion  || undefined,
        };
        const idiomaCrear = this.esPorDefecto ? null : this.idioma;
        const created = await campanasService.landingCrear(this.campanaId, this.templateId, this.conBanner, parametros, this.personalizacionId, idiomaCrear);
        const published = await campanasService.landingPublicar(created.landing.id);
        this.urlPublica = published.url_publica || created.url_publica || '';
        this.fase = 'exito';
        this.$emit('guardado');
      } catch (err) {
        this.errorMsg = err?.response?.data?.error || 'No se pudo crear la landing.';
        this.fase = 'galeria';
      }
    },

    onOmitir() {
      this.$emit('cerrar-modal');
    },

    async copiarUrl() {
      try {
        await navigator.clipboard.writeText(this.urlPublica);
        this.copiado = true;
        setTimeout(() => { this.copiado = false; }, 2000);
      } catch { /* noop */ }
    },

    onCerrar() {
      this.segmentacionNueva = null;
      this.$emit('cerrar-modal');
    },
  },
};
</script>

<style scoped>
/* ── Contenedor principal ──────────────────────── */
.msl-wrap {
  padding: 8px 4px 4px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* ── Cabecera ──────────────────────────────────── */
.msl-header { display: flex; align-items: center; gap: 10px; }

.msl-badge {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: .08em;
  text-transform: uppercase;
  color: var(--q-gold);
  border: 1px solid var(--q-gold);
  border-radius: 4px;
  padding: 1px 6px;
  flex-shrink: 0;
}

.msl-title {
  font-family: var(--q-font-display);
  color: var(--q-text);
  font-size: 1rem;
  margin: 0;
}

/* ── Barra personalización + banner ────────────── */
.msl-pers-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

/* ── Barra superior: idioma + banner ───────────── */
.msl-top-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.msl-top-label {
  font-size: .66rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .07em;
  color: var(--q-muted);
  flex-shrink: 0;
}

.msl-idioma-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}

.msl-idioma-wrap--disabled {
  opacity: .4;
}

.msl-idioma-btns {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}

.msl-idioma-btn {
  background: transparent;
  border: 1px solid var(--q-border-md);
  border-radius: 6px;
  color: var(--q-muted);
  font-size: .72rem;
  font-weight: 600;
  padding: 3px 8px;
  cursor: pointer;
  transition: all .15s;
  white-space: nowrap;
  line-height: 1.4;
}
.msl-idioma-btn:hover:not(:disabled) { border-color: var(--q-gold); color: var(--q-gold); }
.msl-idioma-btn.active { background: color-mix(in srgb, var(--q-gold) 15%, transparent); border-color: var(--q-gold); color: var(--q-gold); font-weight: 700; }
.msl-idioma-btn:disabled { cursor: default; }

/* ── Checkbox banner ───────────────────────────── */
.msl-banner-toggle {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.msl-toggle-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
}

.msl-toggle-input {
  width: 15px;
  height: 15px;
  accent-color: var(--q-gold);
  cursor: pointer;
  flex-shrink: 0;
}

.msl-toggle-box {
  font-size: .8rem;
  font-weight: 600;
  color: var(--q-text);
}

/* ── Body (split layout) ───────────────────────── */
.msl-body {
  display: grid;
  grid-template-columns: 220px 1fr;
  gap: 14px;
  height: calc(80vh - 160px);
  min-height: 360px;
  max-height: 640px;
}

/* ── Columna izquierda ─────────────────────────── */
.msl-left {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 0;
  overflow: hidden;
}

/* Filtros */
.msl-filtros {
  display: flex;
  flex-wrap: nowrap;
  gap: 4px;
  flex-shrink: 0;
  overflow-x: auto;
  padding-bottom: 2px;
  scrollbar-width: none;
}
.msl-filtros::-webkit-scrollbar { display: none; }

.msl-chip {
  background: transparent;
  border: 1px solid var(--q-border-md);
  border-radius: 20px;
  color: var(--q-muted);
  font-size: .7rem;
  padding: 2px 9px;
  cursor: pointer;
  transition: all .15s;
}
.msl-chip:hover { border-color: var(--q-gold); color: var(--q-gold); }
.msl-chip.active { background: var(--q-gold); border-color: var(--q-gold); color: var(--q-gold-on); font-weight: 600; }

/* Grid de tarjetas */
.msl-grid {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-right: 4px;
}
.msl-grid::-webkit-scrollbar { width: 3px; }
.msl-grid::-webkit-scrollbar-track { background: transparent; }
.msl-grid::-webkit-scrollbar-thumb { background: var(--q-border-md); border-radius: 3px; }

/* Tarjeta (lista vertical) */
.msl-card {
  background: var(--q-card);
  border: 1px solid var(--q-border);
  border-radius: 6px;
  cursor: pointer;
  transition: border-color .15s, background .15s;
  flex-shrink: 0;
}
.msl-card:hover { border-color: var(--q-border-md); background: var(--q-hover); }
.msl-card--sel { border-color: var(--q-gold) !important; background: color-mix(in srgb, var(--q-gold) 8%, var(--q-card)); }

.msl-card-inner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
}

.msl-card-check { color: var(--q-gold); font-size: .9rem; flex-shrink: 0; }
.msl-card-nombre { flex: 1; font-size: .82rem; font-weight: 500; color: var(--q-text); }

.msl-cat {
  font-size: .62rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .04em;
  border-radius: 3px;
  padding: 1px 5px;
  flex-shrink: 0;
  background: var(--q-border);
  color: var(--q-muted);
}
.msl-cat--clasica     { background: #0c2a1a; color: var(--q-green); }
.msl-cat--foto        { background: #1a1a0c; color: var(--q-gold); }
.msl-cat--minimal     { background: #0a1828; color: #60b0ff; }
.msl-cat--especial    { background: #2c1216; color: var(--q-red); }
.msl-cat--especial-foto { background: #1a0a2e; color: #c084fc; }
.msl-cat--default     { background: color-mix(in srgb, var(--q-gold) 15%, transparent); color: var(--q-gold); }

/* Etiqueta de sección en el sidebar */
.msl-section-label {
  font-size: .6rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .07em;
  color: var(--q-muted);
  padding: 4px 2px 2px;
  flex-shrink: 0;
}

/* Tarjeta personalización */
.msl-card--pers { border-color: color-mix(in srgb, var(--q-gold) 30%, transparent); }
.msl-pers-icon { color: var(--q-gold); font-size: .75rem; flex-shrink: 0; }
.msl-cat--pers { background: color-mix(in srgb, var(--q-gold) 15%, transparent); color: var(--q-gold); font-size: .75rem; }

/* ── Columna derecha: preview ──────────────────── */
.msl-right {
  position: relative;
  border: 1px solid var(--q-border);
  border-radius: 8px;
  background: var(--q-card-alt);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
}

.msl-preview-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  color: var(--q-muted);
  font-size: .82rem;
  text-align: center;
  padding: 20px;
}
.msl-preview-empty i { opacity: .4; }

.msl-preview-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Iframe escalado al 60% — position:absolute evita que expanda el grid */
.msl-iframe-clip {
  position: absolute;
  inset: 0;
  overflow: hidden;
}

.msl-iframe {
  position: absolute;
  top: 0;
  /* centrado: 50% - (390 * 0.6 / 2) = 50% - 117px */
  left: calc(50% - 117px);
  width: 390px;
  height: 700px;
  border: none;
  transform: scale(0.6);
  transform-origin: top left;
  pointer-events: none;
}

/* ── Estados genéricos ─────────────────────────── */
.msl-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 32px 0;
  color: var(--q-muted);
  font-size: .9rem;
}
.msl-state--error { color: var(--q-red); }
.msl-state--spin  { color: var(--q-text); }

.msl-empty {
  color: var(--q-muted);
  font-size: .82rem;
  text-align: center;
  padding: 16px 0;
}

/* ── Acciones ──────────────────────────────────── */
.msl-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 8px;
  border-top: 1px solid var(--q-border);
}

.msl-btn {
  border: none;
  border-radius: 6px;
  font-size: .83rem;
  font-weight: 600;
  padding: 7px 18px;
  cursor: pointer;
  transition: opacity .15s;
}
.msl-btn:disabled { opacity: .4; cursor: not-allowed; }
.msl-btn--pri { background: var(--q-gold); color: var(--q-gold-on); }
.msl-btn--pri:hover:not(:disabled) { background: var(--q-gold-hover); }
.msl-btn--sec { background: transparent; border: 1px solid var(--q-border-md); color: var(--q-muted); }
.msl-btn--sec:hover { border-color: var(--q-text); color: var(--q-text); }

/* ── Éxito ─────────────────────────────────────── */
.msl-exito {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 8px 0 4px;
  gap: 8px;
}
.msl-exito-icon { font-size: 3rem; color: var(--q-green); }
.msl-exito h6 { font-family: var(--q-font-display); font-size: 1.1rem; color: var(--q-text); margin: 0; }
.msl-exito-sub { color: var(--q-muted); font-size: .82rem; margin: 0; }

.msl-url-row {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--q-card-alt);
  border: 1px solid var(--q-border-md);
  border-radius: 6px;
  padding: 8px 12px;
  width: 100%;
  max-width: 440px;
}
.msl-url-text {
  flex: 1;
  font-family: var(--q-font-mono);
  font-size: .78rem;
  color: var(--q-green);
  word-break: break-all;
  text-align: left;
}
.msl-copy-btn {
  background: transparent;
  border: 1px solid var(--q-border-md);
  border-radius: 4px;
  color: var(--q-muted);
  padding: 4px 8px;
  cursor: pointer;
  flex-shrink: 0;
  transition: color .15s;
}
.msl-copy-btn:hover { color: var(--q-green); border-color: var(--q-green); }

/* ── Params step ───────────────────────────────── */
.msl-params {
  display: flex;
  flex-direction: column;
  gap: 18px;
  max-height: calc(80vh - 160px);
  overflow-y: auto;
  padding-right: 4px;
}
.msl-params::-webkit-scrollbar { width: 3px; }
.msl-params::-webkit-scrollbar-thumb { background: var(--q-border-md); border-radius: 3px; }

.msl-param-group { display: flex; flex-direction: column; gap: 8px; }

/* Label row con botón + */
.msl-label-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.msl-param-label {
  font-size: .7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .07em;
  color: var(--q-muted);
}
.msl-opt { font-weight: 400; text-transform: none; letter-spacing: 0; }

/* Botón "+" */
.msl-add-btn {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 1px solid var(--q-green, #00e676);
  background: rgba(0, 230, 118, 0.1);
  color: var(--q-green, #00e676);
  font-size: .9rem;
  line-height: 1;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: background .12s;
  flex-shrink: 0;
}
.msl-add-btn:hover { background: rgba(0, 230, 118, 0.22); }

/* Formulario inline de agregar */
.msl-inline-add {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 2px;
}
.msl-add-input {
  flex: 1;
  min-width: 120px;
  background: var(--q-input-bg, #0e1822);
  border: 1px solid var(--q-green, #00e676);
  border-radius: 6px;
  color: var(--q-text);
  padding: 5px 10px;
  font-size: .78rem;
}
.msl-add-input--sm { flex: 0 0 90px; min-width: 70px; }
.msl-add-input:focus { outline: none; }
.msl-add-ok, .msl-add-cancel {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  font-size: .75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  flex-shrink: 0;
}
.msl-add-ok { background: rgba(0,230,118,.15); color: var(--q-green, #00e676); }
.msl-add-ok:not(:disabled):hover { background: rgba(0,230,118,.25); }
.msl-add-ok:disabled { opacity: .4; cursor: default; }
.msl-add-cancel { background: rgba(255,68,68,.1); color: var(--q-red, #ff4444); }
.msl-add-cancel:hover { background: rgba(255,68,68,.2); }
.msl-add-error { font-size: .72rem; color: var(--q-red, #ff4444); width: 100%; }

.msl-radio-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.msl-radio-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.msl-radio-hidden { position: absolute; opacity: 0; width: 0; height: 0; }

.msl-radio-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border: 1px solid var(--q-border-md);
  border-radius: 20px;
  font-size: .74rem;
  font-weight: 600;
  color: var(--q-muted);
  cursor: pointer;
  transition: all .15s;
  user-select: none;
}
.msl-radio-pill:hover { border-color: var(--q-gold); color: var(--q-gold); }
.msl-radio-pill.active {
  background: color-mix(in srgb, var(--q-gold) 15%, transparent);
  border-color: var(--q-gold);
  color: var(--q-gold);
}

.msl-radio-pill--lg { padding: 5px 14px; font-size: .78rem; }
.msl-pill-cod { font-weight: 800; }
.msl-pill-desc { font-weight: 400; opacity: .75; font-size: .7rem; }

.msl-select {
  background: var(--q-input-bg, var(--q-card-alt));
  border: 1px solid var(--q-border-md);
  border-radius: 6px;
  color: var(--q-text);
  font-size: .83rem;
  padding: 7px 10px;
  outline: none;
  width: 100%;
  cursor: pointer;
  transition: border-color .15s;
}
.msl-select:focus { border-color: var(--q-gold); }

/* ── Responsive ────────────────────────────────── */
@media (max-width: 600px) {
  .msl-body {
    grid-template-columns: 1fr;
    grid-template-rows: auto 200px;
    height: auto;
    max-height: none;
  }

  .msl-left { overflow: visible; min-height: auto; }

  .msl-grid {
    flex-direction: row;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: visible;
    max-height: none;
    padding-bottom: 4px;
  }

  .msl-card { flex-shrink: 0; min-width: 150px; }

  /* En móvil el ResizeObserver ajusta el scale automáticamente */

  .msl-actions { flex-direction: column; }
  .msl-btn { width: 100%; text-align: center; }
}
</style>
